"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumFeatureType = exports.BillingState = exports.BillingType = exports.BillingChangelogOrigin = exports.StripeSubscriptionAction = void 0;
var StripeSubscriptionAction;
(function (StripeSubscriptionAction) {
    StripeSubscriptionAction["START"] = "Start";
    StripeSubscriptionAction["CANCEL"] = "Cancel";
    StripeSubscriptionAction["PAY"] = "Pay";
})(StripeSubscriptionAction = exports.StripeSubscriptionAction || (exports.StripeSubscriptionAction = {}));
var BillingChangelogOrigin;
(function (BillingChangelogOrigin) {
    BillingChangelogOrigin["SYNC"] = "SYNC";
    BillingChangelogOrigin["EXPLICIT_SYNC"] = "EXPLICIT_SYNC";
    BillingChangelogOrigin["FREE_TRIAL_CREATOR"] = "FREE_TRIAL_CREATOR";
    BillingChangelogOrigin["WEBHOOK"] = "WEBHOOK";
    BillingChangelogOrigin["FREE_TO_PAID_CANCELLATION"] = "FREE_TO_PAID_CANCELLATION";
})(BillingChangelogOrigin = exports.BillingChangelogOrigin || (exports.BillingChangelogOrigin = {}));
var BillingType;
(function (BillingType) {
    BillingType["MONTHLY"] = "Monthly";
    BillingType["YEARLY"] = "Yearly";
    BillingType["FREE_TRIAL"] = "FreeTrial";
})(BillingType = exports.BillingType || (exports.BillingType = {}));
var BillingState;
(function (BillingState) {
    BillingState["ACTIVE"] = "active";
    BillingState["PAST_DUE"] = "past_due";
    BillingState["UNPAID"] = "unpaid";
    BillingState["CANCELED"] = "canceled";
    BillingState["INCOMPLETE"] = "incomplete";
    BillingState["INCOMPLETE_EXPIRED"] = "incomplete_expired";
    BillingState["TRIALING"] = "trialing";
    BillingState["PAUSED"] = "paused";
})(BillingState = exports.BillingState || (exports.BillingState = {}));
var PremiumFeatureType;
(function (PremiumFeatureType) {
    PremiumFeatureType["SHOW_SPRINT_SUMMARY"] = "ShowSprintSummary";
    PremiumFeatureType["ICE_BREAKERS"] = "IceBreakers";
    PremiumFeatureType["ACTION_ITEMS"] = "ActionItems";
    PremiumFeatureType["HAPPINESS_INDEX"] = "HappinessIndex";
    PremiumFeatureType["BOARD_EXPORT"] = "BoardExport";
    PremiumFeatureType["ANALYTICS"] = "Analytics";
    PremiumFeatureType["MEETING_RECAP"] = "MeetingRecap";
    PremiumFeatureType["POLLS"] = "Polls";
    PremiumFeatureType["PLANNING"] = "Planning";
})(PremiumFeatureType = exports.PremiumFeatureType || (exports.PremiumFeatureType = {}));
//# sourceMappingURL=billing.js.map